import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function SystemExplainer() {
  return <section className="w-full bg-[#0f172a] py-24 px-4 md:px-6" data-id="element-155">
      <div className="max-w-3xl mx-auto" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-bold text-[#faf5ef] mb-8" data-id="element-158">
            Hier ist das System:{' '}
            <span className="text-[#d4a574]" data-id="element-159">Der 3‑Zonen‑Check</span>
          </h2>

          <div className="space-y-6 text-lg text-[#cbd5e1] leading-relaxed" data-id="element-160">
            <p data-id="element-161">
              In 15 Minuten ordnest du dich ein — ohne Geräte, ohne
              kompliziertes Gerede. Und dann kommt der Teil, den fast niemand
              macht:
            </p>
            <p className="font-medium text-[#faf5ef]" data-id="element-162">
              Du trackst 14 Nächte so minimal, dass du es wirklich durchziehst.
            </p>
            <p data-id="element-163">
              Nicht, um ein "Schlaf-Nerd" zu werden. Sondern um endlich zu
              wissen:
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#1e293b] p-8 rounded-2xl border border-[#334155] mb-12 shadow-xl" data-id="element-164">
          <ul className="space-y-4" data-id="element-165">
            {['Was verschlechtert dich wirklich?', 'Was verbessert dich wirklich?', 'Und wann ist es Zeit, es medizinisch abzuklären (ohne Panik)?'].map((item, i) => <li key={i} className="flex items-start" data-id="element-166">
                <CheckCircle2 className="w-6 h-6 text-[#2dd4bf] mr-3 flex-shrink-0 mt-0.5" data-id="element-167" />
                <span className="text-[#faf5ef] text-lg font-medium" data-id="element-168">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-169">
          <h3 className="text-2xl font-bold text-[#d4a574] mb-4" data-id="element-170">
            Beweise. Nicht Meinungen. Nicht Hoffnung.
          </h3>
          <p className="text-[#94a3b8] mb-10 text-lg" data-id="element-171">
            Beweise, welche 2–3 Dinge bei dir 80% bringen. Und genau so denken
            Männer, die im Alltag funktionieren müssen:
            <br data-id="element-172" />
            <span className="text-[#faf5ef] font-semibold" data-id="element-173">
              Minimaler Aufwand. Maximale Wirkung.
            </span>
          </p>

          <Button variant="primary" withIcon className="w-full md:w-auto" onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-174">
            Jetzt den Plan holen
          </Button>
        </motion.div>
      </div>
    </section>;
}